import IMCategories from './IMCategories';

export default IMCategories;
